import { post } from 'utils/api';
import { SESSION_DATA_REPORT_URL } from './endpointURLs';

// CDB-2017 — one page of the Session Data Report: { columns, results, page, limit, totalPages, totalResults }.
export const fetchSessionDataReport = (data, { page = 1, limit = 20 } = {}) => {
  return post(`${SESSION_DATA_REPORT_URL}?page=${page}&limit=${limit}`, data);
};
